import { Fragment } from 'react';
import { Ingredients } from '../../../../../pages/customize/components/Ingredients/Ingredients';
import { getPairingDataImg } from '../../utils/utils';
import HorizontalLine from '../../generic/HorizontalLine';
import PairingImage from './components/PairingImage';
import { customerId } from '../../customize/const';
import {
  SaveRecipes,
  Variant as SaveVariant,
} from '../../../../../components/SaveRecipes/SaveRecipes';
import { windowVars } from '@hungryroot/environment';
import styles from './CustomizationCard.module.css';
import {
  getLikeDislikeRatingFromPairing,
  ApiV1LikeDislikeEnum as LikeDislike,
  LikedDislikedIndicator,
} from '@hungryroot/ratings';
import { BinaryRatingRecipeScore } from '@hungryroot/pho';
import { AuthGuard } from '../../../../../components/auth/AuthGuard/AuthGuard';

const CustomizationCard = ({ pairingData, openModal, isRecipesPage }) => {
  let pairingImage = getPairingDataImg(pairingData);

  // If is on the recipes page wrap title in link component
  const TitleLinkWrapper = ({ children }) => {
    if (isRecipesPage) {
      return (
        <a
          href={`/recipes/${pairingData.slug}`}
          onClick={(e) => e.preventDefault()}
        >
          {children}
        </a>
      );
    } else {
      return <Fragment>{children}</Fragment>;
    }
  };

  const renderRating = () => {
    const rating = getLikeDislikeRatingFromPairing(pairingData);
    if (rating === LikeDislike.Liked || rating === LikeDislike.Disliked) {
      return (
        <LikedDislikedIndicator
          rating={rating}
          testid={'liked-disliked-indicator'}
        />
      );
    }

    return (
      <BinaryRatingRecipeScore
        recipeScore={pairingData.recipe_score}
        numberOfRatings={pairingData.num_ratings}
        testid={`binary-rating-recipe-score-${pairingData.id}`}
      />
    );
  };

  return (
    <div
      data-testid={`customization-card-${pairingData.id}`}
      className={`customization-card ${styles.card}`}
      onClick={openModal}
    >
      {!windowVars.isPrecheckout() && (
        <AuthGuard
          authenticated={(auth) => {
            return (
              <SaveRecipes
                customerId={customerId}
                variant={SaveVariant.Card}
                className={styles.save}
                pairingName={pairingData.name}
                pairingId={pairingData.id}
                segment={{
                  location: 'card',
                  path: isRecipesPage === true ? 'cookbook' : 'customization',
                }}
                isFavorite={pairingData.is_favorited}
                testid={`customize-save-${pairingData.id}`}
                customer={auth.customerData}
              />
            );
          }}
        />
      )}
      {pairingImage && pairingData.is_featured ? (
        <div
          className="pairing-image"
          style={{ backgroundImage: pairingImage }}
        ></div>
      ) : (
        <PairingImage
          ingredients={pairingData.ingredients}
          style="customization"
        />
      )}

      <div className="hr-ptb-16 hr-plr-16">
        <TitleLinkWrapper>
          {pairingData.name ? (
            <div className="hr-ptb-8 hr-demi customization-card-title">
              {pairingData.name}
            </div>
          ) : (
            <div className="hr-ptb-8 hr-demi customization-card-title">
              {pairingData.dish_type ? pairingData.dish_type.name : ''}
            </div>
          )}
        </TitleLinkWrapper>
        <div className="averageRatingContainer hr-mb-8">{renderRating()}</div>
        <HorizontalLine />
        {pairingData.name && pairingData.is_featured ? (
          <div className="grayHorizontalRule"></div>
        ) : null}
        <Ingredients
          ingredients={pairingData.ingredients}
          isRecipesPage={isRecipesPage}
        />
      </div>
    </div>
  );
};

export default CustomizationCard;
